export default {
  data() {
    return {
      // eslint-disable-next-line
      locationCountry: [
        "Australia"
      ],
      // eslint-disable-next-line
      locationState: [
        "ACT",
        "NSW",
        "QLD",
        "NT",
        "SA",
        "TAS",
        "VIC",
        "WA"
      ]
    };
  }
};
